"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiUpload = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const storage_1 = require("firebase/storage");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const hooks_1 = require("../hooks");
const util_1 = require("./util");
const media_1 = require("../media");
const classnames_1 = __importDefault(require("classnames"));
const firestore_1 = require("firebase/firestore");
const firestore_web_1 = require("comodel/firestore-web");
const storage = (0, storage_1.getStorage)(firebase_app_1.default);
const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
const wait = (time) => new Promise((resolve) => setTimeout(resolve, time));
const checkExistFileName = (_a) => __awaiter(void 0, [_a], void 0, function* ({ fileName, rootPath, fieldPath, }) {
    const collectionRef = (0, firestore_1.collection)(firestore, rootPath);
    const queryRef = (0, firestore_1.query)(collectionRef, ...(0, firestore_web_1.getQueryConstraints)({
        filter: { [fieldPath]: fileName },
    }));
    const snapshot = yield (0, firestore_1.getDocs)(queryRef);
    return !snapshot.empty;
});
const MultiUpload = (props) => {
    var _a;
    const { register, filesFieldPath, values, onChange, name, rootPath, hasError, accept, mode, files, onFiles, onRemove, errors, setErrors, disposition, isUniqueFileName, fileNameFieldPath, validators, } = props;
    const inputRef = (0, react_1.useRef)(null);
    const toast = (0, hooks_1.useToast)();
    const [progress, setProgress] = (0, react_1.useState)({});
    const [completed, setCompleted] = (0, react_1.useState)(false);
    const [dragging, setDragging] = (0, react_1.useState)(false);
    const handleFileUpload = (newFiles) => __awaiter(void 0, void 0, void 0, function* () {
        if (!newFiles)
            return;
        const _newFileArray = Array.from(newFiles);
        const validFiles = [];
        for (const [_index, file] of _newFileArray.entries()) {
            const index = _index + ((files === null || files === void 0 ? void 0 : files.length) || 0);
            let error = false;
            for (const validator of validators !== null && validators !== void 0 ? validators : []) {
                const result = yield validator(file);
                if (result === null || result === void 0 ? void 0 : result.error) {
                    yield toast({
                        message: result.message,
                        duration: 3000,
                    });
                    error = true;
                    continue;
                }
            }
            if (error)
                continue;
            const fileName = file.name.replace(/\s*(?:のコピー| - コピー)?(?:\s*\([0-9]+\)|[0-9]+)*\.[a-zA-Z0-9]+$/, "") || "";
            if (isUniqueFileName && rootPath) {
                const isExist = yield checkExistFileName({
                    fileName,
                    rootPath: rootPath,
                    fieldPath: fileNameFieldPath || "fileName",
                });
                if (isExist) {
                    setErrors === null || setErrors === void 0 ? void 0 : setErrors((prev) => {
                        const next = [...prev];
                        next[index] = "ファイル名が重複しています";
                        return next;
                    });
                }
            }
            validFiles.push({ file, fileName });
        }
        const updatedFiles = [...validFiles];
        onFiles === null || onFiles === void 0 ? void 0 : onFiles(updatedFiles);
        const uploadPromises = validFiles.map((e, _index) => __awaiter(void 0, void 0, void 0, function* () {
            const index = _index + ((files === null || files === void 0 ? void 0 : files.length) || 0);
            const { file, fileName } = e;
            const path = `${rootPath || ""}/${Date.now()}_${_index}`;
            const fileRef = (0, storage_1.ref)(storage, path);
            const contentType = file.type;
            if (accept &&
                accept[0] !== "." &&
                !(contentType === null || contentType === void 0 ? void 0 : contentType.startsWith(accept.replaceAll("*", "")))) {
                const errorMessage = "ファイルタイプが間違っています";
                yield toast({
                    message: errorMessage,
                    duration: 10000,
                });
                setErrors === null || setErrors === void 0 ? void 0 : setErrors((prev) => {
                    const next = [...prev];
                    next[index] = errorMessage;
                    return next;
                });
                return null;
            }
            const encodeRFC5987ValueChars = (str) => {
                return encodeURIComponent(str)
                    .replace(/['()]/g, (match) => "%" + match.charCodeAt(0).toString(16))
                    .replace(/\*/g, "%2A")
                    .replace(/%20/g, " ");
            };
            const task = (0, storage_1.uploadBytesResumable)(fileRef, file, {
                contentType,
                cacheControl: "public, max-age=2592000",
                contentDisposition: `${disposition || "inline"}; filename*=UTF-8''${encodeRFC5987ValueChars(file.name)}`,
            });
            task.on("state_changed", (snapshot) => {
                if (snapshot.state === "running") {
                    const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setProgress((prev) => (Object.assign(Object.assign({}, prev), { [fileName]: percent })));
                }
                if (snapshot.state === "error" || snapshot.state === "canceled") {
                    setProgress((prev) => (Object.assign(Object.assign({}, prev), { [fileName]: 0 })));
                }
            });
            try {
                yield task;
                const newValue = (0, util_1.encodeSrc)({
                    protocol: "gs",
                    host: firebase_app_1.default.options.storageBucket,
                    path: `/${path}`,
                    contentType: file.type,
                    name: file.name,
                });
                return newValue;
            }
            catch (_b) {
                return null;
            }
        }));
        const newValues = (yield Promise.all(uploadPromises)).filter((v) => v !== null);
        const updatedValues = [...(values || []), ...newValues];
        onChange(updatedValues);
        yield wait(500);
        setProgress({});
        setCompleted(true);
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    });
    const handleRemove = (index) => {
        onRemove === null || onRemove === void 0 ? void 0 : onRemove(index);
        const newValues = values.filter((_, i) => i !== index);
        onChange(newValues);
    };
    const getDisplayValue = (value) => {
        if (mode !== "filename") {
            return value && typeof value === "object"
                ? JSON.stringify(value || "")
                : value || "";
        }
        else {
            const searchParams = new URLSearchParams(value);
            return searchParams.get("name") || "";
        }
    };
    const validateFileName = (index, fileName) => __awaiter(void 0, void 0, void 0, function* () {
        const file = files === null || files === void 0 ? void 0 : files[index];
        if (!file)
            return;
        if (isUniqueFileName && rootPath) {
            const isExist = yield checkExistFileName({
                fileName,
                rootPath: rootPath,
                fieldPath: fileNameFieldPath || "fileName",
            });
            if (isExist) {
                setErrors === null || setErrors === void 0 ? void 0 : setErrors((prev) => {
                    const next = [...prev];
                    next[index] = "ファイル名が重複しています";
                    return next;
                });
            }
            else {
                setErrors === null || setErrors === void 0 ? void 0 : setErrors((prev) => {
                    const next = [...prev];
                    next[index] = undefined;
                    return next;
                });
            }
        }
    });
    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const droppedFiles = e.dataTransfer.files;
        handleFileUpload(droppedFiles);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", style: { position: "relative", marginBottom: "10px" } },
            react_1.default.createElement("i", { className: "mdi mdi-cloud-upload-outline" }),
            " \u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E",
            react_1.default.createElement("input", Object.assign({}, (accept ? { accept } : undefined), { type: "file", multiple: true, style: {
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    opacity: 0,
                }, ref: inputRef, onChange: (e) => handleFileUpload(e.target.files) }))),
        react_1.default.createElement("div", { onDragOver: (e) => {
                e.preventDefault();
                setDragging(true);
            }, onDragLeave: () => setDragging(false), onDrop: handleDrop, className: "border-pr", style: {
                border: "2px dashed #ccc",
                borderColor: dragging ? "#2d73b9" : "#ccc",
                borderRadius: "4px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100px",
                transition: "border 0.3s ease",
                marginBottom: "10px",
            } },
            react_1.default.createElement("p", null, "\u30C9\u30E9\u30C3\u30B0&\u30C9\u30ED\u30C3\u30D7")),
        react_1.default.createElement(react_bootstrap_1.ListGroup, null, (_a = files === null || files === void 0 ? void 0 : files.filter((file) => !(file === null || file === void 0 ? void 0 : file.source))) === null || _a === void 0 ? void 0 : _a.map((file, index) => (react_1.default.createElement(react_bootstrap_1.ListGroup.Item, { key: index, className: (0, classnames_1.default)("w-100 d-flex flex-column align-items-start", {
                "has-error": !!errors,
            }) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("w-100 d-flex justify-content-between align-items-center"), style: { gap: "16px" } },
                react_1.default.createElement("div", { className: "w-100 d-flex flex-column align-items-start" },
                    values && values[index] && (react_1.default.createElement("div", { className: "mb-2 w-100" },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "url", value: getDisplayValue(values[index]), readOnly: mode === "filename", disabled: mode === "filename" }))),
                    react_1.default.createElement("div", { className: "mb-2 w-100" },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "\u30D5\u30A1\u30A4\u30EB\u540D:"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, Object.assign({ type: "text" }, register(`${filesFieldPath}.${index}.fileName`, {
                            onChange: (e) => {
                                validateFileName(index, e.target.value);
                            },
                        }), { isInvalid: !!(errors === null || errors === void 0 ? void 0 : errors[index]) })),
                        (errors === null || errors === void 0 ? void 0 : errors[index]) && (react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, errors === null || errors === void 0 ? void 0 : errors[index]))),
                    values && values[index] ? (react_1.default.createElement(media_1.File, { style: {
                            border: "1px solid #ccc",
                            marginBottom: "10px",
                        }, src: values[index] })) : (react_1.default.createElement(react_bootstrap_1.ProgressBar, { now: progress[file.file.name] || 20, style: {
                            height: 4,
                            width: "150px",
                            opacity: progress[file.file.name] || 0 > 0 ? 1 : 0.4,
                        } }))),
                react_1.default.createElement("div", { className: "d-flex align-items-center" },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-danger", size: "sm", onClick: () => handleRemove(index) },
                        react_1.default.createElement("i", { className: "mdi mdi-close" })))))))),
        react_1.default.createElement(react_bootstrap_1.ToastContainer, { position: "bottom-end", className: "position-fixed m-4" },
            react_1.default.createElement(react_bootstrap_1.Toast, { show: completed, onClose: () => setCompleted(false), autohide: true },
                react_1.default.createElement(react_bootstrap_1.Toast.Header, { className: "justify-content-between" },
                    react_1.default.createElement("p", null, "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u5B8C\u4E86")),
                react_1.default.createElement(react_bootstrap_1.Toast.Body, null, "\u3059\u3079\u3066\u306E\u30D5\u30A1\u30A4\u30EB\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F")))));
};
exports.MultiUpload = MultiUpload;
